import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core'
import moment from 'moment-mini'
import { Moment } from 'moment-mini'

@Component({
  selector: 'list-date-li-btn',
  templateUrl: './list-date-li-btn.component.html',
  styleUrls: ['./list-date-li-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListDateLiBtnComponent {
  @Input() date: Moment
  @Input() index: number
  @Input() selectedDate: Moment
  @Input() isFormValid: boolean
  @Input() selectedLanguage: string
  @Input() errorMessage: string

  @Output() onDateRemoved = new EventEmitter<number>()
  @Output() onDateClicked = new EventEmitter<Moment>()

  removeDate(dateIndex: number) {
    this.onDateRemoved.emit(dateIndex)
  }

  dateClicked(date: Moment) {
    this.onDateClicked.emit(date)
  }
}
